'use client';

import { useLayoutEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

import { releaseCurrentPopup } from '@/activity-orchestration/lifecycle/release-current-popup';
import { resolveActiveScene } from '@/activity-orchestration/scene';
import { useActivityQueueStore } from '@/store/activity-queue';

import type { TDisplayTab } from '@/activity-orchestration/types';

/** 路由变化时同步可信场景，并释放不属于新场景的当前弹窗。 */
export default function ActivitySceneSync() {
    const pathname = usePathname();
    // undefined 区分首次挂载和“当前场景为空”。
    const prevSceneRef = useRef<TDisplayTab | null | undefined>(undefined);

    // 在 paint 前同步，避免旧场景弹窗短暂闪现。
    useLayoutEffect(() => {
        const nextScene = resolveActiveScene(pathname);
        if (prevSceneRef.current === nextScene) {
            return;
        }
        prevSceneRef.current = nextScene;

        const { current, setActiveScene, onScene } = useActivityQueueStore.getState();

        setActiveScene(nextScene);

        if (current) {
            releaseCurrentPopup('route_change', current.id);
        }

        if (nextScene) {
            onScene(nextScene);
        }
    }, [pathname]);

    return null;
}
